// extracted by mini-css-extract-plugin
module.exports = {"buttonActive":"Buttons_buttonActive__ScwZJ","buttonInactive":"Buttons_buttonInactive__lLB3w","reviewNavigationButton":"Buttons_reviewNavigationButton__1ZiQp"};